/* eslint-disable max-len */
import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {GlobalStyle} from '../styles';

import Button from '../components/Button';

import {ReactComponent as CNLogo} from './../assets/cnlogobig.svg';
import {ReactComponent as Chrome} from './../assets/chrome.svg';
import {ReactComponent as Firefox} from './../assets/firefox.svg';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: black;
    padding-top: 77px;
    padding-bottom: 197px;
`;

const Browsers = styled.div`
    display: flex;
    justify-content: space-around;
    width: 646px;
    width: 646px;
`;

const Title = styled.h2`
    color: #ffffff;
    font-size: 49px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 59px;
    text-align: center;
    margin-bottom: 84px;
    max-width: 851px;
`;

const DownloadBrowser = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    button {
        margin-top: 48px;
    }
`;

const CustomButton = styled(Button)`
    font-size: 12px;
    padding: 12px 35px;
`;

const Unsupported = props => {
    const {t} = useTranslation();
    const handleRedirect = browser => {
        if (browser === 'chrome') {
            window.location.href = 'https://www.google.com/chrome/';
        } else {
            window.location.href = 'https://www.mozilla.org/en-US/firefox/new/';
        }
    };
    return (
        <>
            <GlobalStyle />
            <Container>
                <CNLogo />
                <Title>{t('unsupported')}</Title>
                <Browsers>
                    <DownloadBrowser>
                        <Chrome />
                        <CustomButton
                            value="Download Chrome"
                            light
                            onClick={() => handleRedirect('chrome')}
                        />
                    </DownloadBrowser>
                    <DownloadBrowser>
                        <Firefox />
                        <CustomButton
                            value="Download Firefox"
                            light
                            onClick={() => handleRedirect('firefox')}
                        />
                    </DownloadBrowser>
                </Browsers>
            </Container>
        </>
    );
};

export default Unsupported;
